export default function getRateFromTimestamp(wellRates, timestamp) {
  const closestTime = timestamp - timestamp % 1800000;
  const result = wellRates.filter(({ rowNumber }) => rowNumber === closestTime);
  return result.length === 1 ? result[0].value : NaN;
}
